<div id="consultNoteHeader">
  <div class="border rounded container-fluid p-0" [ngClass]="{ 'inactive': !patientAttachment.client.active }">
    <div class="inactive-label" [ngClass]="{ 'd-none': patientAttachment.client.active }">INACTIVE</div>
    <div class="mx-1 row small-gutters">
      <div class="col-auto">
        <strong>ID</strong>
        <div>{{ patientAttachment.id }}</div>
      </div>
      <div class="col-auto">
        <strong>STATUS</strong>
        <div>{{ statusOptions[patientAttachment.status]?.display }}</div>
      </div>
      <div class="col-auto">
        <div>
          <strong>CLIENT</strong>
          @if (!patientAttachment.client.active) {
            <span class="inactive-client">INACTIVE</span>
          }
        </div>
        <div>
          <a target="_blank" routerLink="/capture-admin/client-management/clients/{{ patientAttachment.client.id }}">
            {{ patientAttachment.client.name }}
          </a>
          <app-copy-to-clipboard [text]="patientAttachment.client.name" />
        </div>
        @if (patientAttachment.client.entityTypes) {
          <div>
            Type: {{ patientAttachment.client.entityTypes | joinList }}
          </div>
        }
        @if (patientAttachment.ehrAccess) {
          <div
            class="indicator-pill indicator-pill-green indicator-pill-full-width">
            EHR Access
          </div>
        }
      </div>
      <div class="col-auto">
        <strong>CE-PATIENT</strong>
        <app-patient-name
          [patient]="patientAttachment.patient"
          [canViewPatient]="canViewPatient" />
        @if (showHealthGorillaTag) {
          <span
            class="indicator-pill indicator-pill-green"
            title="HIE Patient Created">
            HIE
          </span>
        }
      </div>
      <div class="col-auto text-center">
        <strong class="m-0 p-0">NEXT EXPIRATION DATE</strong>
        <div>{{ patientAttachment.nextHighValueExpirationDate | date: 'MM/dd/yyyy' }}</div>
        <div class="m-0 p-0"><small>FOR HIGH VALUE WIP</small></div>
      </div>
      <div class="col-auto text-center">
        <strong class="m-0 p-0">ESTIMATED VALUES</strong>
        <app-consult-note-estimated-values [patientAttachment]="patientAttachment" />
        <div class="m-0 p-0"><small>FOR FAXED OFFICE</small></div>
      </div>
      <div class="col-auto">
        <strong>OFFICE</strong>
        <app-consult-note-office [providerOffice]="patientAttachment.associatedProviderOffice" />
      </div>
      <div class="col-auto">
        <strong>INBOUND FAX ID</strong>
        <div>
          @if (patientAttachment.inboundFax?.id) {
            <a
              target="_blank"
              routerLink="/capture-admin/communications/inbound-faxes/{{ patientAttachment.inboundFax.id }}">
              {{ patientAttachment.inboundFax.id }}
            </a>
          } @else {
            <app-blank-value-dash />
          }
        </div>
      </div>
      <div class="col-auto">
        <strong>RELATED NOTES</strong>
        @if (openRelatedAttachmentsCount > 0) {
          <div>
            There {{ openRelatedAttachmentsCount === 1 ? 'is' : 'are' }}
            <a target="_blank" routerLink="/capture-admin/consult-notes/{{ patientAttachment.id }}/related">
              {{ openRelatedAttachmentsCount }} related {{ openRelatedAttachmentsCount === 1 ? 'note.' : 'notes.' }}
            </a>
          </div>
        } @else {
          <div>There are no related consult notes.</div>
        }
        <div class="m-0 p-0"><small>FOR PATIENT & OFFICE</small></div>
      </div>
      <div class="col-auto">
        <app-consult-note-assigned-to [patientAttachment]="patientAttachment" />
      </div>
    </div>
  </div>
</div>
